import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Iconset from './icons';
import VideoDOM from './videoDOM';
import NoteIntro from './noteintro';

//styles
import '../styles/transition-group.scss';


class SpaceVideo extends React.Component{

	constructor(props){
		super(props);
		this.state = {
			ready : false,
			readyCount : 0,
			showNote : false,
			videoIsPlaying : false,
			introScreen : true,
			canTrigger : false,
			toolTipActive : true
		}

		this.addHandler();

	}
	play(){
			this.refs.firstvideo.playVideo();
	  	this.refs.secondvideo.playVideo(); 
	}

	pause(){
		
	
			this.refs.firstvideo.pauseVideo();
	  	this.refs.secondvideo.pauseVideo();
	  
	}
 

 	componentDidMount(){
 			this.props.mainPlay();
 	}
 	
  componentWillUnmount(){
 		this.removeHandler();
 	}
  

  toggleVideo(){
  	if(this.props.activeVideo == 0 ){
  		this.props.changeActiveVideo(1,this.refs.firstvideo);
  	}else{
 			this.props.changeActiveVideo(0,this.refs.firstvideo);
  	}
  }
  

  keyBoardHandler(event){
		if(event.keyCode == 32 && this.state.canTrigger){
			event.target.blur();
			this.toggleVideo();
		}
	}
	touchHandler(event){
		if(this.state.canTrigger){
			this.toggleVideo();
		}
	}


  addHandler(){
  	this.keyBoardHandlerAction = (event) => this.keyBoardHandler(event);
  	this.touchHandlerAction = (event) => this.touchHandler(event);
  	
  	window.addEventListener('keydown', this.keyBoardHandlerAction ,false);
  	window.addEventListener('touchstart', this.touchHandlerAction ,false);
  }
	
	removeHandler(){
		window.removeEventListener('keydown', this.keyBoardHandlerAction);
		window.removeEventListener('touchstart', this.touchHandlerAction);
	}

	//fire play from outside(main timeline)
	componentWillReceiveProps(nextProps){

		if(nextProps.isPlaying != this.state.videoIsPlaying){
				if(nextProps.isPlaying){

					//console.log('chapter 2 play');
					this.play();
				}else{
					//console.log('chapter 2 pause');
					this.pause();
				}
			this.setState({
				videoIsPlaying : nextProps.isPlaying
			});	
		}

		if(nextProps.timecode > 9){
			this.setState({
				canTrigger : true
			})
		}

	}


	render(){
		return (
			<main className="space-video-holder">
				<ReactCSSTransitionGroup
					component= "div"
					className="main-tooltip-holder"
			    transitionName="fade"
			    transitionEnterTimeout={500}
			    transitionLeaveTimeout={300}>
					{ (this.props.timecode > 9 && this.props.timecode < 30) && 
					 	<div className="main-tooltip">
					 		<Iconset.loader />
					 		<span>Press space to interact</span>
					 	</div>
					}
				</ReactCSSTransitionGroup>
				{/*show intro*/}
						<ReactCSSTransitionGroup
							component= "div"
								className="absolute inner-note-intro"
			          transitionName="fade"
			          transitionEnterTimeout={500}
			          transitionLeaveTimeout={300}>
			          {(this.props.timecode > 0 && this.props.timecode < 6) &&
			          	<NoteIntro headline="Doing good" />
			          }
			      </ReactCSSTransitionGroup>

        		{/*press space*/}
						<ReactCSSTransitionGroup
							component= "div"
								className="absolute inner-note-space"
			          transitionName="fade"
			          transitionAppear={true}
     						transitionAppearTimeout={500}
			          transitionEnterTimeout={500}
			          transitionLeaveTimeout={300}>
			          {(this.props.timecode > 9 && this.props.showNote && this.props.timecode < 30) &&
			          	<div className="space-note" >
			          		<h1>press space</h1>
			          	</div>
			          }
			      </ReactCSSTransitionGroup>

				{this.props.firstSession && 
					<div className={"absolute inner-intro-video active-video-" + this.props.activeVideo}>
						<VideoDOM 
							src={_assets.loaded.heliVideo} 
							timeupdate ={this.props.timeupdate}
							ended={this.props.ended}
							name="video-0"
							ref="firstvideo"
							groupName="spaceVideo"
							muted="true"/>
						<VideoDOM 
							src={_assets.loaded.ifrontVideo} 
							timeupdate ={this.props.timeupdate}
							name="video-1"
							ref="secondvideo"
							groupName="spaceVideo"/>
					</div>
				}
			</main>
		);
	}
}

export default SpaceVideo;


// WEBPACK FOOTER //
// ./src/scripts/spaceVideo.js